var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _g, _g2, _g3, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyYourSquad = function SvgEmptyYourSquad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 320,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0FA",
    offset: "58.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100.002%",
    y2: "50.001%",
    id: "EmptyYourSquad_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyYourSquad_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E7F6",
    offset: "65.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E5F5",
    offset: "55.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.002%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyYourSquad_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyYourSquad_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100.003%",
    y2: "50%",
    id: "EmptyYourSquad_svg__n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C9EB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EF",
    offset: "11.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF8",
    offset: "41.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "69.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.435%",
    y1: "65.188%",
    x2: "76.154%",
    y2: "36.437%",
    id: "EmptyYourSquad_svg__p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302B8E",
    offset: "48.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "34.069%",
    y1: "26.368%",
    x2: "63.323%",
    y2: "68.514%",
    id: "EmptyYourSquad_svg__q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302B8E",
    offset: "48.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.719%",
    y1: "0%",
    x2: "52.776%",
    y2: "109.395%",
    id: "EmptyYourSquad_svg__r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.992%",
    x2: "99.999%",
    y2: "49.992%",
    id: "EmptyYourSquad_svg__t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DBF0",
    offset: "25.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FB",
    offset: "73%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyYourSquad_svg__u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD03E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B67E9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D8F2",
    offset: "34.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE0F5",
    offset: "59.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEEF9",
    offset: "81.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.195%",
    y1: "31.798%",
    x2: "30.175%",
    y2: "68.254%",
    id: "EmptyYourSquad_svg__x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D33",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "99.999%",
    y2: "50%",
    id: "EmptyYourSquad_svg__y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".001%",
    y1: "49.998%",
    x2: "99.999%",
    y2: "49.998%",
    id: "EmptyYourSquad_svg__A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C9E4",
    offset: "42.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DAED",
    offset: "57.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA",
    offset: "84.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "EmptyYourSquad_svg__B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyYourSquad_svg__C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C9EB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D7F0",
    offset: "21.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB",
    offset: "72.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyYourSquad_svg__D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "EmptyYourSquad_svg__E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyYourSquad_svg__F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DDF1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBE9",
    offset: "55.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC2E5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "EmptyYourSquad_svg__G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyYourSquad_svg__H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "33.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DDEF",
    offset: "59.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyYourSquad_svg__I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A9D0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2F9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyYourSquad_svg__J"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A9D0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.956%",
    y1: "49.071%",
    x2: "10.719%",
    y2: "50.362%",
    id: "EmptyYourSquad_svg__K"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BDE2",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A9D0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.001%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__L"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A9D0",
    offset: "40.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BBE0",
    offset: "68.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7",
    offset: "41.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D6EC",
    offset: "58.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FA",
    offset: "89.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__N"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyYourSquad_svg__O"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4DAF2",
    offset: "56.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.995%",
    x2: "99.999%",
    y2: "49.995%",
    id: "EmptyYourSquad_svg__P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C8E2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DAEB",
    offset: "14.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA",
    offset: "40.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "55.5%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.214%",
    y1: "-36.945%",
    x2: "50%",
    y2: "89.738%",
    id: "EmptyYourSquad_svg__S"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.214%",
    y1: "-36.945%",
    x2: "50%",
    y2: "109.746%",
    id: "EmptyYourSquad_svg__V"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "8.585%",
    x2: "50%",
    y2: "125.022%",
    id: "EmptyYourSquad_svg__Y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".001%",
    y1: "50%",
    x2: "100.001%",
    y2: "50%",
    id: "EmptyYourSquad_svg__Z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EC",
    offset: "9.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "40.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "99.999%",
    y2: "50%",
    id: "EmptyYourSquad_svg__aa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EC",
    offset: "9.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "40.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.001%",
    y1: "50%",
    x2: ".003%",
    y2: "50%",
    id: "EmptyYourSquad_svg__ab"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A35A0",
    offset: "30.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241E77",
    offset: "89.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5481.654%",
    y1: "50.002%",
    x2: "-5381.654%",
    y2: "50.002%",
    id: "EmptyYourSquad_svg__ac"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A35A0",
    offset: "30.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241E77",
    offset: "89.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: ".001%",
    y2: "50%",
    id: "EmptyYourSquad_svg__ad"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353097",
    offset: "30.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251F7A",
    offset: "74.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyYourSquad_svg__ae"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyYourSquad_svg__af"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyYourSquad_svg__ag"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "419.154%",
    y1: "49.997%",
    x2: "519.154%",
    y2: "49.997%",
    id: "EmptyYourSquad_svg__ah"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C9EB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EF",
    offset: "11.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF8",
    offset: "41.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "69.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100.001%",
    y2: "50%",
    id: "EmptyYourSquad_svg__ai"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C9EB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EF",
    offset: "11.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF8",
    offset: "41.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "69.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.289%",
    y1: "101.622%",
    x2: "66.914%",
    y2: "3.324%",
    id: "EmptyYourSquad_svg__aj"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#443BB5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332793",
    offset: "49.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231574",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-10669.631%",
    y1: "199.249%",
    x2: "-10780.199%",
    y2: "-18.245%",
    id: "EmptyYourSquad_svg__ak"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#443BB5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332793",
    offset: "49.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231574",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.797%",
    y1: "53.869%",
    x2: "63.904%",
    y2: "46.876%",
    id: "EmptyYourSquad_svg__al"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231574",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#261879",
    offset: "31.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2189",
    offset: "71.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392B99",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.936%",
    y1: "65.182%",
    x2: "35.629%",
    y2: "38.319%",
    id: "EmptyYourSquad_svg__am"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231574",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332793",
    offset: "50.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#443BB5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-12081.152%",
    y1: "188.774%",
    x2: "-11909.039%",
    y2: "12.591%",
    id: "EmptyYourSquad_svg__an"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231574",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332793",
    offset: "50.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#443BB5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.958%",
    y1: "46.061%",
    x2: "52.112%",
    y2: "52.375%",
    id: "EmptyYourSquad_svg__ao"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584FD3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342792",
    offset: "65.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231574",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.001%",
    y1: "50%",
    x2: ".002%",
    y2: "50%",
    id: "EmptyYourSquad_svg__ap"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DCF9",
    offset: "11.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEFFC",
    offset: "41.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFE",
    offset: "71.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "98.7%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v91.493h19.825v4.51h.009a9.695 9.695 0 0 0 1.264 4.393v18.552l-1.273.235v1.536a76.135 76.135 0 0 0 17.161 3.793v-12.001l1.233-2.225c9.495 1.754 19.768.317 26.811-3.75 4.989-2.882 7.555-6.637 7.722-10.42v-4.623h19.797V0H0Z",
    id: "EmptyYourSquad_svg__s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.448 256.077-26.105-38.736s-26.506 39.303-26.682 39.589a10.412 10.412 0 0 0-1.632 5.48c0 4.186 2.765 8.369 8.292 11.563 11.058 6.386 28.986 6.386 40.042 0 5.53-3.194 8.293-7.377 8.293-11.563 0-2.157-.74-4.312-2.208-6.333Z",
    id: "EmptyYourSquad_svg__R"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.223 240.404-22.88-33.948-22.878 33.948a9.406 9.406 0 0 0-1.936 5.55c0 3.667 2.423 7.334 7.267 10.134 9.691 5.597 25.402 5.597 35.092 0 4.845-2.8 7.27-6.467 7.27-10.134a9.427 9.427 0 0 0-1.935-5.55Z",
    id: "EmptyYourSquad_svg__U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.31 227.473c-.131-.215-19.967-29.629-19.967-29.629s-19.836 29.414-19.968 29.63a7.78 7.78 0 0 0-1.22 4.098c0 3.133 2.068 6.264 6.206 8.653 8.275 4.78 21.69 4.78 29.965 0 4.137-2.389 6.206-5.52 6.206-8.653a7.78 7.78 0 0 0-1.222-4.099Z",
    id: "EmptyYourSquad_svg__X"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.4%",
    y: "-8.1%",
    width: "124.7%",
    height: "122.8%",
    filterUnits: "objectBoundingBox",
    id: "EmptyYourSquad_svg__Q"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-14.1%",
    y: "-9.3%",
    width: "128.2%",
    height: "126%",
    filterUnits: "objectBoundingBox",
    id: "EmptyYourSquad_svg__T"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-16.5%",
    y: "-10.9%",
    width: "133%",
    height: "130.5%",
    filterUnits: "objectBoundingBox",
    id: "EmptyYourSquad_svg__W"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.202824519 0",
    "in": "shadowBlurOuter1"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.481 169.976a46.38 46.38 0 0 0-1.65 1.004h7.066a11.316 11.316 0 0 1 1.459-4.326l-.005.008a54.04 54.04 0 0 0-6.87 3.314Z",
    fill: "#DAE0F5",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.254 175.022v2.077a30.696 30.696 0 0 0-6.61 2.79c-3.039 1.756-5.228 3.86-6.493 6.124v9.36l-3.853.711h17.868l1.874-.346v-6.802l1.233-2.225c.12.022.242.038.362.059 1.176-2.552 3.502-4.93 6.878-6.88a30.7 30.7 0 0 1 6.609-2.79l-1.851-2.078h-16.017Z",
    fill: "url(#EmptyYourSquad_svg__a)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.645 170.82-6.783 3.918-.003.002v15.647l-.001-.003a11.023 11.023 0 0 1-1.511 5.814 54.068 54.068 0 0 0 6.9-3.325c4.35-2.512 7.848-5.447 10.355-8.648a19.302 19.302 0 0 0-5.413-5.131l3.893-2.249a36.736 36.736 0 0 0-7.437-6.024Z",
    fill: "url(#EmptyYourSquad_svg__b)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.26 183.122 3.91-.602c-2.47-5.35-7.378-10.258-14.195-14.196a55.866 55.866 0 0 0-3.673-1.932v13.495l.186.028v3.207h13.773Z",
    fill: "url(#EmptyYourSquad_svg__c)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.493 225.9v1.896c-11.006 4.576-23.874 7.4-37.265 8.27.98.066 1.964.12 2.95.166 18.598.82 37.13-2.176 52.183-8.436l-2.364-1.896h-15.504Z",
    fill: "url(#EmptyYourSquad_svg__d)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.066 187.205c-1.349-10.202-8.62-19.845-20.565-27.368a28.827 28.827 0 0 1 2.697 8.816c.152 1.16.227 2.328.225 3.498v-.015 18.07c.002.16 0 .32 0 .482v.477c-.17 9.384-5.327 18.554-14.832 26.178h17.868c10.838-8.693 16.026-19.397 14.607-30.138Z",
    fill: "url(#EmptyYourSquad_svg__e)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.547 191.276 3.673-.978a42.888 42.888 0 0 0 3.875 4.216h3.347l4.032-.194a25.96 25.96 0 0 1 2.13-14.477v-7.415.002c-.077-5.012 1.889-10.032 5.898-14.603a76.575 76.575 0 0 0-4.185 2.236c-12.656 7.31-20.25 16.884-21.71 27.024v7.233l-4.033.193 6.973.001v-3.238Zm17.057-19.333v.127-.127Z",
    fill: "url(#EmptyYourSquad_svg__f)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.254 162.252v4.802c6.365-2.695 13.579-4.42 21.035-5.184a87.78 87.78 0 0 0-21.035.382Z",
    fill: "url(#EmptyYourSquad_svg__g)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.553 191.868h-4.72c.542.347 1.092.682 1.648 1.005a51.552 51.552 0 0 0 3.508 1.84 17.489 17.489 0 0 1-.436-2.845Z",
    fill: "#DAE0F5",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.044 207.276c-.465.434-.941.855-1.428 1.264l.877.704v8.57a61.062 61.062 0 0 0 10.482-4.736 48.889 48.889 0 0 0 2.698-1.68l-12.63-4.122Z",
    fill: "url(#EmptyYourSquad_svg__h)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.62 215.35c-17.165-.758-33.366-4.919-45.85-11.75l14.31-8.265c21.458 11.52 55.143 11.252 76.028-.81a43.013 43.013 0 0 0 7.936-5.802l17.626 5.753a51.28 51.28 0 0 1-3.362 2.95l3.283 1.365c10.839-8.694 16.026-19.397 14.607-30.138-1.435-10.858-9.578-21.084-22.927-28.794-30.828-17.805-80.987-17.805-111.814 0-16.479 9.517-24.819 22.677-22.883 36.103l4.032-.194c-1.838-12.74 6.076-25.226 21.711-34.257 29.25-16.893 76.843-16.893 106.093 0 12.667 7.316 20.393 17.018 21.754 27.32 1.086 8.222-1.908 16.42-8.503 23.61l-17.628-5.751a25.478 25.478 0 0 0 4.455-6.775l-3.923-.572c-2.228 5.107-6.834 9.785-13.318 13.53-19.786 11.427-51.98 11.427-71.766 0-9.38-5.417-14.309-12.445-14.796-19.556h20.217c.185 1.483.66 2.915 1.396 4.216l3.853-.712c-3.037-5.484-.548-11.417 6.494-15.483a30.696 30.696 0 0 1 6.61-2.79l-1.852-2.078a35.411 35.411 0 0 0-7.619 3.215c-5.344 3.087-8.412 7.106-8.887 11.295h-20.212c.487-7.111 5.417-14.139 14.796-19.556 19.306-11.15 50.425-11.418 70.304-.808l-14.322 8.272a36.76 36.76 0 0 0-6.14-2.418l-1.85 2.078a30.747 30.747 0 0 1 6.61 2.79c10.322 5.96 10.322 15.66 0 21.622-7.042 4.067-17.316 5.505-26.81 3.75l-1.233 2.226c10.944 2.022 22.786.365 30.904-4.324 11.418-6.594 11.872-17.155 1.377-24.07l14.324-8.273c5.587 3.494 9.635 7.722 11.748 12.3l3.909-.6c-2.47-5.35-7.378-10.26-14.195-14.197-21.363-12.338-56.123-12.338-77.487 0-20.884 12.061-21.348 31.517-1.4 43.91l-14.312 8.266c-5.663-3.449-10.264-7.362-13.688-11.65l-3.673.978c3.904 4.89 9.257 9.32 15.91 13.162 13.35 7.71 31.055 12.413 49.854 13.24 18.597.82 37.129-2.175 52.182-8.435l-2.364-1.896c-14.28 5.939-31.863 8.78-49.51 8.002Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.62 215.35c-17.165-.758-33.366-4.919-45.85-11.75l14.31-8.265c21.458 11.52 55.143 11.252 76.028-.81a43.013 43.013 0 0 0 7.936-5.802l17.626 5.753a51.28 51.28 0 0 1-3.362 2.95l3.283 1.365c10.839-8.694 16.026-19.397 14.607-30.138-1.435-10.858-9.578-21.084-22.927-28.794-30.828-17.805-80.987-17.805-111.814 0-16.479 9.517-24.819 22.677-22.883 36.103l4.032-.194c-1.838-12.74 6.076-25.226 21.711-34.257 29.25-16.893 76.843-16.893 106.093 0 12.667 7.316 20.393 17.018 21.754 27.32 1.086 8.222-1.908 16.42-8.503 23.61l-17.628-5.751a25.478 25.478 0 0 0 4.455-6.775l-3.923-.572c-2.228 5.107-6.834 9.785-13.318 13.53-19.786 11.427-51.98 11.427-71.766 0-9.38-5.417-14.309-12.445-14.796-19.556h20.217c.185 1.483.66 2.915 1.396 4.216l3.853-.712c-3.037-5.484-.548-11.417 6.494-15.483a30.696 30.696 0 0 1 6.61-2.79l-1.852-2.078a35.411 35.411 0 0 0-7.619 3.215c-5.344 3.087-8.412 7.106-8.887 11.295h-20.212c.487-7.111 5.417-14.139 14.796-19.556 19.306-11.15 50.425-11.418 70.304-.808l-14.322 8.272a36.76 36.76 0 0 0-6.14-2.418l-1.85 2.078a30.747 30.747 0 0 1 6.61 2.79c10.322 5.96 10.322 15.66 0 21.622-7.042 4.067-17.316 5.505-26.81 3.75l-1.233 2.226c10.944 2.022 22.786.365 30.904-4.324 11.418-6.594 11.872-17.155 1.377-24.07l14.324-8.273c5.587 3.494 9.635 7.722 11.748 12.3l3.909-.6c-2.47-5.35-7.378-10.26-14.195-14.197-21.363-12.338-56.123-12.338-77.487 0-20.884 12.061-21.348 31.517-1.4 43.91l-14.312 8.266c-5.663-3.449-10.264-7.362-13.688-11.65l-3.673.978c3.904 4.89 9.257 9.32 15.91 13.162 13.35 7.71 31.055 12.413 49.854 13.24 18.597.82 37.129-2.175 52.182-8.435l-2.364-1.896c-14.28 5.939-31.863 8.78-49.51 8.002Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.604 190.61a19.928 19.928 0 0 0 2.715 9.946l11.9-6.874c-9.627-5.981-14.499-13.608-14.615-21.254v18.182Z",
    fill: "#CED3F8",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M150.604 172.07v-.126z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M244.107 194.525c-20.884 12.062-54.569 12.33-76.027.81v14.4c9.599 3.18 20.362 5.122 31.54 5.615 17.646.778 35.23-2.064 49.51-8.002l1.486 1.192c.487-.409.963-.83 1.428-1.264v-18.553a43.013 43.013 0 0 1-7.937 5.802Z",
    fill: "url(#EmptyYourSquad_svg__i)",
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m258.488 190.827-6.444-2.104v18.553l14.264 4.655v-14.505a49.195 49.195 0 0 0 3.362-2.95l-11.182-3.649Z",
    fill: "#BBC0E6",
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "M266.308 197.426v18.551l3.283 1.366V198.79l-3.283-1.365z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M269.59 198.791v18.552c9.506-7.625 14.664-16.794 14.832-26.178l.001-.002v-.475c0-.161.002-.321 0-.482v-18.07c0 9.55-5.167 18.902-14.832 26.655Z",
    fill: "#A5ABCC",
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M224.083 161.337a30.747 30.747 0 0 0-6.61-2.79V177.1a30.747 30.747 0 0 1 6.61 2.79c.805.463 1.58.976 2.32 1.535 7.926-5.99 7.158-14.613-2.32-20.086Zm-69.398 11.98c.457 6.68 4.835 13.285 13.138 18.551h7.08v-18.551h-20.218Z",
    fill: "#BBC0E6",
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.902 173.317v18.551c.185 1.483.66 2.916 1.396 4.216v-18.551a11.436 11.436 0 0 1-1.396-4.216Z",
    fill: "#CED3F8",
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "M176.298 177.533v18.551l3.853-.712v-18.551l-3.853.712z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M186.645 161.337c-7.042 4.067-9.53 10-6.494 15.484v9.192c1.265-2.264 3.454-4.368 6.494-6.124a30.696 30.696 0 0 1 6.61-2.79v-18.551a30.696 30.696 0 0 0-6.61 2.79Z",
    fill: "url(#EmptyYourSquad_svg__j)",
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M169.481 151.424c-9.38 5.417-14.31 12.445-14.796 19.556h13.146c.536-.34 1.082-.676 1.65-1.004a54.04 54.04 0 0 1 6.87-3.314c1.464-2.579 3.967-4.974 7.433-6.977a35.411 35.411 0 0 1 7.619-3.215l1.851 2.078v3.704a87.668 87.668 0 0 1 24.22.003v-3.707l1.85-2.078a36.76 36.76 0 0 1 6.14 2.418l14.321-8.272c-19.879-10.61-50.998-10.342-70.304.808Z",
    fill: "url(#EmptyYourSquad_svg__k)",
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M258.488 179.915a25.478 25.478 0 0 1-4.455 6.775l4.455 1.454v-8.23Z",
    fill: "#A5ABCC",
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M199.311 217.68c-18.799-.829-36.505-5.532-49.853-13.242-6.654-3.843-12.007-8.271-15.911-13.162v18.552c3.904 4.89 9.257 9.32 15.91 13.162 13.35 7.71 31.055 12.412 49.854 13.242 18.597.819 37.129-2.177 52.182-8.436v-18.552c-15.053 6.26-33.585 9.255-52.182 8.435Z",
    fill: "url(#EmptyYourSquad_svg__l)",
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m242.645 152.269-14.324 8.273c4.965 3.271 7.475 7.357 7.538 11.454l.003.002v2.74l6.783-3.917v-18.552Z",
    fill: "#A5ABCC",
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M235.86 171.996c.07 4.564-2.9 9.14-8.916 12.616-4.618 2.667-10.44 4.352-16.616 4.938l-.556.125-.578-.031a52.117 52.117 0 0 1-13.154-.708v12.008c13.096 1.403 26.962-.18 38.305-4.744a11.023 11.023 0 0 0 1.513-5.816l.001.003V174.74l.003-.002v-2.74l-.003-.002Z",
    fill: "url(#EmptyYourSquad_svg__m)",
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M242.645 152.269v18.552c4.888 3.056 8.598 6.675 10.865 10.6.32-.558.614-1.13.883-1.713V164.57c-2.113-4.579-6.161-8.807-11.748-12.301Z",
    fill: "#C2C7E5",
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M254.393 164.57v15.138c.056-.122.119-.243.172-.365l3.737.545v-15.92l-3.91.602Z",
    fill: "#A5ABCC",
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M126.308 172.547v17.458h.007c-.04 1.507.046 3.015.26 4.508v-18.551a26.78 26.78 0 0 1-.267-3.415Z",
    fill: "#CED3F8",
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M280.164 168.831c-1.361-10.302-9.087-20.004-21.754-27.32-29.25-16.893-76.843-16.893-106.093 0-15.635 9.03-23.549 21.517-21.71 34.257v11.319c1.46-10.14 9.054-19.715 21.71-27.024a72.81 72.81 0 0 1 4.185-2.237c2.549-2.905 5.92-5.63 10.118-8.054 21.364-12.338 56.124-12.338 77.487 0 4.103 2.37 7.508 5.093 10.112 8.05 1.434.711 2.831 1.458 4.191 2.241 10.19 5.886 17.178 13.318 20.23 21.363a25.735 25.735 0 0 0 1.524-12.595Z",
    fill: "url(#EmptyYourSquad_svg__n)",
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m128.344 175.877-.306.015-1.464.07v18.551l4.032-.193v-18.552l-2.262.109z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M153.77 203.6a86.475 86.475 0 0 0 14.31 6.143v-14.408l-14.31 8.265Z",
    fill: "#ADB5DB",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m250.082 176.845-7.437-24.576v18.552c2.731 1.675 5.231 3.7 7.437 6.024Zm-95.397-3.528c.457 6.68 4.835 13.285 13.138 18.551h4.73l-17.868-18.551Zm109.988 38.08-12.63-22.674v18.553l12.63 4.121Z",
    fill: "#E8ECF7",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyYourSquad_svg__o)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M173.786 107.793H143.94l2.02 4.937h27.825z"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.977 105.827c-1.434.234-1.85 2.547-1.132 3.998.445.497 1.57.966 1.57.966s4.528 1.859 5.547 1.94c1.02.083 3.282-.299 3.467-2.04-.174-1.063-1.067-1.354-2.165-2.008-1.428-.848-2.653-2.079-3.804-2.645-.947-.466-3.483-.21-3.483-.21Z",
    fill: "url(#EmptyYourSquad_svg__p)",
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.729 104.354c-.7.115-2.947.67-2.947.67s-.833 2.332.48 2.745c2.551.8 4.724-.911 3.722-1.488-.674-.383-1.338-.82-1.256-1.927Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M145.931 112.265c-1.049-.084-5.712-1.994-5.712-1.994a6.06 6.06 0 0 1-1.565-.952c.05.174.114.343.191.506.445.497 1.57.966 1.57.966s4.528 1.859 5.547 1.94c1.02.083 3.282-.299 3.467-2.04-.007-.036-.02-.068-.027-.105-.48 1.433-2.51 1.758-3.471 1.68Z",
    fill: "#131147",
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M144.417 106.626c-.19-.253-.631-.925-1.41-.37-.816.58-.998 1.278-.903 1.859.096.58 1.773.15 1.837.063.063-.087.476-1.552.476-1.552Z",
    fill: "#362E94",
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M145.186 107.35a3.423 3.423 0 0 0-1.521 1.48.459.459 0 1 1-.83-.394 4.318 4.318 0 0 1 1.992-1.93.458.458 0 1 1 .36.844Zm1.414.905a3.404 3.404 0 0 0-1.518 1.48.46.46 0 0 1-.83-.396 4.295 4.295 0 0 1 1.99-1.93.46.46 0 1 1 .358.846Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M140.711 58.585c2.295 8.533 3.912 15.201 3.912 22.05 0 7.831-1.818 17.533-1.901 24.097.073 2.013-2.212 3.592-3.177 1.814-.04-.585.212-1.323.132-2.184-.475-5.09-2.5-15.004-.521-20.93-1.982-8.57-9.395-17.376-8.588-24.1 2.48-1.232 8.246-1.35 10.143-.747Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#423EAF",
    fillRule: "nonzero",
    d: "M137.323 61.337v1.433l-1.24-.717z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M110.381 86.928c-.626-1.311-2.962-1.062-4.154.033-.353.567-.487 1.778-.487 1.778s-.517 4.87-.31 5.87c.205 1.003 1.206 3.069 2.929 2.759.97-.464 1.001-1.405 1.32-2.642.413-1.608 1.253-3.13 1.474-4.393.181-1.04-.772-3.405-.772-3.405Z",
    fill: "url(#EmptyYourSquad_svg__q)",
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M112.565 89.16c-.305-.64-1.468-2.644-1.468-2.644s-2.471-.147-2.5 1.23c-.054 2.675 2.197 4.282 2.469 3.159.18-.756.413-1.515 1.5-1.746Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M105.869 94.448c-.214-1.03.315-6.041.315-6.041a6.03 6.03 0 0 1 .476-1.77 3.345 3.345 0 0 0-.433.324c-.353.567-.487 1.778-.487 1.778s-.517 4.87-.31 5.87c.205 1.003 1.206 3.069 2.929 2.759.031-.017.06-.04.092-.055-1.51-.06-2.39-1.921-2.582-2.865Z",
    fill: "#131147",
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M110.856 91.416c.19-.252.712-.865-.039-1.458-.784-.62-1.506-.6-2.037-.346-.529.254.353 1.745.454 1.781.102.038 1.622.023 1.622.023Z",
    fill: "#362E94",
    fillRule: "nonzero"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M110.377 92.358a3.42 3.42 0 0 0-1.846-1.045.46.46 0 0 1 .146-.908c.932.18 1.78.662 2.41 1.372a.46.46 0 0 1-.71.581Zm-.472 1.611a3.404 3.404 0 0 0-1.845-1.044.46.46 0 0 1 .146-.907c.932.179 1.78.66 2.411 1.37a.46.46 0 0 1-.712.581Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M126.367 80.47c-6.606.427-9.425 4.014-14.649 5.854-.814.287-1.337.09-2.148.368-1.436 1.425.717 3.2 2.63 2.567 6.322-1.758 18.937-3.43 19.925-8l-5.758-.788ZM149.998 1.6c-.282-.282-.977 2.56-.962 2.303.143-2.366.07-3.903-.112-3.903-.252 0-.583 3.027-.583 3.826 0-.797-.04-2.965-.506-3.479-.16-.176-.292 2.766-.292 3.59 0-.902-.172-3.474-.601-3.427-.43.048-.22 2.74-.052 3.624 0 0-1.315-1.645-1.315-1.008 0 .402.793 1.172.793 2.797 0 1.132.34 1.234.347 1.662-.356 6.048-1.051 12.292-2.092 14.682-.491 1.127-3.466 5.302-7.901 7.919 0 0-.225 2.686 2.45 4.496 6.082-4.922 7.936-7.93 8.76-10.766 1.433-4.934 1.467-14.89 1.497-16.452.015-.008.03-.013.046-.022.166-1.413.739-5.627.523-5.842Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M129.034 51.674c.648-5.91-2.14-11.485-2.65-15.176-.323-2.329-.556-5.057 1.554-5.714 1.606-.529 3.25-.934 4.918-1.213 3.577-.646 4.645.458 6.022 2.776 1.571 2.645 3.106 5.519 3.824 8.411.322 1.298-3.247 4.116-2.832 9.712 3.162 4.781 4.63 15.584 5.596 24.07.368 2.557 2.4 5.32.078 6.643-4.763 2.714-18.29 4.208-21.208 2.021-1.24-.929-2.278-2.738-2.313-3.544 6.125-5.71 2.215-22.229 7.01-27.986Z",
    fill: "url(#EmptyYourSquad_svg__r)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M131.27 24.296c.081-1.401 4.408 1.386 4.303 3.232-.088 1.503.177 3.017.74 3.21.653.473 2.596 5.46 1.43 6.626-4.068-1.665-6.111-4.967-8.963-6.82 1.48-.303 2.23-1.714 2.49-6.248Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M139.203 18.797c2.791 6.95.46 11.687-1.274 13.439.254-1.856-1.574-3.297-2.276-3.713.607-1.25 3.55-9.726 3.55-9.726Z",
    fill: "#0F0E49",
    fillRule: "nonzero"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M134.174 30.435c.59.141 1.207.125 1.788-.047-.318-.57-.456-1.716-.39-2.86.106-1.846-4.221-4.633-4.302-3.232-.013.228-.028.443-.044.656l.14.03c-.51 2.53.705 4.94 2.808 5.453Z",
    fill: "#FBC096",
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m130.07 23.07 1.276-3.193h8.085v4.867c0 2.69-1.81 4.868-4.043 4.868-2.165 0-3.917-2.052-4.023-4.63l-.563.014-.732-1.925Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M134.858 16.484a.54.54 0 0 1 .074-.001c4.412.112 4.743 3.409 4.5 3.955-1.4.5-2.282-.447-3.16-.376-.424.035-1.068.568-1.78 1.48-.765.98-1.599 2.25-2.322 2.212-.314-.013-.408-1.065-.876-1.093-.393-.022-.788.344-.742.946.06.811.826 1.302.714 1.693-.189.646-1.801-.512-1.77-2.813.032-2.285 1.557-6.157 5.362-6.003Z",
    fill: "#0F0E49",
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M131.266 25.3c0 1.057 2.023 7.002 3.226 7.723-2.053.407-5.73-1.391-6.015-3.504-.158-2.042-1.025-10.11 4.137-12.583.387.509-2.74 4.949-2.544 5.723a8.656 8.656 0 0 0 1.196 2.641Z",
    fill: "#0F0E49",
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M128.148 31.64c-3.132-1.927-4.773-4.147-6.181-6.51-1.819-3.052-2.67-9.309-2.923-12.438-.006-.07-.001-.137-.003-.203.421-1.36 1.709-4.917 1.537-5.168-.227-.329-1.39 1.856-1.323 1.607.517-1.929 1.27-2.99.797-3.327-.205-.145-1.321 2.34-1.466 3.125.145-.784.844-3.035.367-3.513-.125-.202-1.023 2.666-1.173 3.477.164-.887.677-3.364.245-3.48-.416-.111-.922 2.573-.922 3.554-.202 0 .124-1.024-.262-1.41-.32-.32-.773 1.064-.418 2.914.216 1.126.33 1.784.25 2.218.109 6.69.837 12.499 2.176 15.099.78 1.602 4.207 6.71 6.53 8.334 4.533 3.167 6.241-2.14 2.77-4.278Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.573 103.497h18.387a3.42 3.42 0 0 0 .003-1.923h-18.39v1.923Z",
    fill: "url(#EmptyYourSquad_svg__t)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M260.573 62.072c4.431-4.432 10.419-2.333 14.522-4.977 3.984-2.566 5.382-7.319 13.538-8.96-4.693 2.917-7.314 10.355-12.991 16.034-4.835 4.837-11.228 3.911-15.069 8.774V62.072Z",
    fill: "url(#EmptyYourSquad_svg__u)",
    fillRule: "nonzero"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M258.902 60.522v42.009c.028.3.215.56.49.683a2.61 2.61 0 0 0 2.364 0 .83.83 0 0 0 .489-.683V60.522h-3.343Z",
    fill: "url(#EmptyYourSquad_svg__v)",
    fillRule: "nonzero"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M261.756 59.84a2.613 2.613 0 0 0-2.364 0 .721.721 0 0 0 0 1.365c.743.377 1.62.377 2.364 0a.721.721 0 0 0 0-1.366Z",
    fill: "#807DFB",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m305.371 293.546-1.653-.955 17.813-10.287-42.857-24.752-17.812 10.287 1.651.954c1.997 1.154 1.998 3.024 0 4.178-1.997 1.153-5.235 1.153-7.232 0l-1.652-.955-17.812 10.288 14.48 10.288h3.332l1.652-.954c1.997-1.154 5.235-1.154 7.232 0 1.998 1.153 1.997 3.023 0 4.176l-1.651.955 14.48 10.288h3.332l17.813-10.288 1.652.954c1.997 1.154 5.235 1.154 7.232 0 1.997-1.153 1.997-3.024 0-4.177Z",
    fill: "url(#EmptyYourSquad_svg__w)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m302.038 291.621-1.652-.954 17.813-10.287-42.857-24.753-17.813 10.288 1.652.954c1.997 1.153 1.997 3.023 0 4.177-1.997 1.154-5.235 1.154-7.233 0l-1.651-.954-17.813 10.287 17.813 10.288 1.652-.954c1.997-1.154 5.235-1.154 7.232 0 1.997 1.154 1.997 3.024 0 4.177l-1.652.954 17.812 10.288 17.813-10.288 1.652.954c1.998 1.154 5.235 1.154 7.232 0 1.997-1.153 1.997-3.023 0-4.177Z",
    fill: "url(#EmptyYourSquad_svg__x)",
    fillRule: "nonzero"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M259.18 268.794c.495.265.913.653 1.215 1.126.616-1.034.215-2.226-1.214-3.051l-1.652-.954v1.924h.001l1.65.955Z",
    fill: "#FCBA06",
    fillRule: "nonzero"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m318.199 280.38-17.813 10.287 1.652.954.014.009 16.147-9.325-.001-.001v-1.924Z",
    fill: "#E19100",
    fillRule: "nonzero"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBA06",
    fillRule: "nonzero",
    d: "M232.485 280.38h-.001v1.924l17.813 10.288v-1.925z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M259.18 289.713c-1.996-1.154-5.234-1.154-7.232 0l-1.651.954v1.925l1.652-.954c1.997-1.154 5.235-1.154 7.232 0 .494.265.912.65 1.216 1.122.613-1.033.211-2.223-1.216-3.047Z",
    fill: "url(#EmptyYourSquad_svg__y)",
    fillRule: "nonzero"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBA06",
    fillRule: "nonzero",
    d: "M257.53 294.845v1.924l17.811 10.288v-1.925z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#E19100",
    fillRule: "nonzero",
    d: "M275.341 305.132v1.925l17.813-10.288v-1.925z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M303.534 293.737c-.012.747-.51 1.491-1.496 2.061-1.997 1.154-5.234 1.154-7.232 0l-1.652-.954v1.925l1.652.954c1.998 1.154 5.235 1.154 7.232 0 .987-.57 1.484-1.315 1.496-2.062h.001v-1.924h-.001Z",
    fill: "url(#EmptyYourSquad_svg__z)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.841 126.085c-1.898-1.097-4.423-1.602-6.902-1.528h-3.886v.637a10.29 10.29 0 0 0-2.057.89c-3.534 2.057-3.513 5.389.043 7.445.639.362 1.313.654 2.014.873v.665h4.661c2.242-.037 4.464-.546 6.17-1.537 3.535-2.057 3.517-5.389-.043-7.445Z",
    fill: "url(#EmptyYourSquad_svg__A)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M125.036 133.532c-1.79-1.034-2.686-2.392-2.682-3.747l.008-3.09c-.003 1.356.89 2.713 2.681 3.748 3.56 2.055 9.31 2.055 12.844 0 1.757-1.021 2.636-2.357 2.64-3.696l-.008 3.09c-.003 1.339-.882 2.674-2.638 3.696-3.536 2.056-9.287 2.056-12.845 0Z",
    fill: "url(#EmptyYourSquad_svg__B)",
    fillRule: "nonzero"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M125.043 130.443c-3.558-2.055-3.577-5.388-.043-7.443 3.536-2.055 9.288-2.055 12.846 0 3.56 2.055 3.576 5.388.041 7.444-3.535 2.054-9.285 2.054-12.844-.001Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m136.105 126.298-6.722.342.21-1.511h-1.858l-.504 2.754 8.874-.512v-1.073z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyYourSquad_svg__C)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M62.53 168.775h.002l-7.185-4.15 4.614-5.23h-6.468l-2.268 2.57-.322.094-7.186-4.15 1.59 5.797-9.056 2.665 10.038.92.056.205-4.933 5.592h6.467l4.615-5.23 10.04.918h-.003z"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBA06",
    fillRule: "nonzero",
    d: "M37.25 153.919v3.99l1.59 5.798v-3.99z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#E19100",
    fillRule: "nonzero",
    d: "M53.494 155.405v3.99l-4.615 5.23v-3.989z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBA06",
    fillRule: "nonzero",
    d: "M46.027 163.868v3.99l10.04.918v-3.989l-10.04-.919z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M29.785 162.382v3.99l10.038.918v-3.989l-10.038-.92Zm16.242 1.486v3.99l-4.615 5.23v-3.99l4.615-5.23Z",
    fill: "#E19100",
    fillRule: "nonzero"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBA06",
    fillRule: "nonzero",
    d: "M41.412 169.099v3.989l-1.59-5.798v-3.989l1.59 5.798z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD03E",
    fillRule: "nonzero",
    d: "m53.494 155.405-4.615 5.231 7.187 4.151-10.04-.919-4.614 5.23-1.59-5.797-10.037-.92 9.055-2.664-1.59-5.798 7.186 4.151z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.157 203.152c-2.804-1.618-6.53-2.363-10.19-2.255h-8.486v.941a15.189 15.189 0 0 0-3.036 1.315c-5.218 3.036-5.188 7.956.063 10.991.943.534 1.94.965 2.973 1.288v.984h9.63c3.31-.057 6.59-.808 9.108-2.271 5.22-3.036 5.194-7.956-.062-10.992Z",
    fill: "url(#EmptyYourSquad_svg__D)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M309.597 209.021c-2.643-1.527-3.966-3.532-3.959-5.533l.012-2.564c-.005 2.004 1.314 4.008 3.959 5.535 5.255 3.035 13.744 3.035 18.964.002 2.594-1.51 3.892-3.482 3.898-5.458l-.012 2.562c-.006 1.977-1.304 3.948-3.897 5.457-5.22 3.036-13.71 3.036-18.965 0Z",
    fill: "url(#EmptyYourSquad_svg__E)",
    fillRule: "nonzero"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M309.597 211.584c-2.643-1.528-3.966-3.532-3.959-5.534l.012-2.563c-.005 2.003 1.314 4.007 3.959 5.534 5.255 3.035 13.744 3.035 18.964.002 2.594-1.51 3.892-3.481 3.898-5.458l-.012 2.563c-.006 1.976-1.304 3.947-3.897 5.456-5.22 3.036-13.71 3.036-18.965 0Z",
    fill: "url(#EmptyYourSquad_svg__F)",
    fillRule: "nonzero"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M309.597 214.146c-2.643-1.527-3.966-3.532-3.959-5.533l.012-2.564c-.005 2.003 1.314 4.007 3.959 5.535 5.255 3.034 13.744 3.034 18.964.001 2.594-1.51 3.892-3.481 3.898-5.457l-.012 2.562c-.006 1.976-1.304 3.948-3.897 5.457-5.22 3.036-13.71 3.036-18.965-.001Z",
    fill: "url(#EmptyYourSquad_svg__G)",
    fillRule: "nonzero"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M309.609 206.46c-5.254-3.035-5.283-7.957-.064-10.99 5.22-3.035 13.714-3.035 18.966 0 5.256 3.033 5.28 7.955.062 10.99-5.22 3.034-13.71 3.034-18.964 0Z",
    fill: "#F1F1F6",
    fillRule: "nonzero"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BFE8",
    fillRule: "nonzero",
    d: "m326.562 199.96-10.738.546.332-2.414h-2.966l-.806 4.4 14.178-.818z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m38.534 203.936 2.45.002 2.634-1.52c.002 0 .014-2.152.014-2.152-1.056.042-3.14-.107-4.214-.629l-.073.042v.001L25.8 191.857h-.346c0 .606-.248 1.96-1.273 2.552-.232.133-.487.22-.751.257-.526.103-1.044.227-1.545.372a.25.25 0 0 1-.066-.011 18.718 18.718 0 0 0-1.542-.37c-1.659-.25-2-2.078-1.995-2.81h-1l-3.307 1.91c-.178.262-.41.48-.682.642a2.12 2.12 0 0 1-.751.257c-.071.014-.139.036-.21.05l-7.391 4.27c-.024.038-.052.075-.075.114a1.037 1.037 0 0 1-.447.434c-1.025.591-3.363.73-4.413.73L0 202.408c1.263-.001 4.416.202 4.84 1.164.184.317.396.617.635.895.865.856-1.125 2.291-2.024 2.81l2.618 1.522c.09-.053.203-.113.325-.177l-.306.177 7.737.008a3.5 3.5 0 0 1 .635 2.01l14.6.01 3.638-2.022 4.78.004 2.637-1.52c-.895-.52-2.866-1.955-1.995-2.81.147-.174.285-.355.414-.542Z",
    fill: "url(#EmptyYourSquad_svg__H)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M5.728 191.423c-.002-.836-1.474-1.888-2.21-2.316l.018 6.278c.736.428 2.209 1.48 2.21 2.315l-.018-6.277Z",
    fill: "#F7F7FC",
    fillRule: "nonzero"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m29.31 195.384-.017-6.277c-.745.43-2.24 1.49-2.237 2.327l.017 6.279c-.001-.838 1.493-1.898 2.238-2.328Z",
    fill: "#BDC1E4",
    fillRule: "nonzero"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M11.751 198.635c2.58-1.49 6.745-1.49 9.308 0 1.273.74 1.91 1.708 1.914 2.679l-.018-6.278c-.003-.97-.64-1.94-1.914-2.679-2.563-1.49-6.727-1.49-9.308 0-1.297.75-1.944 1.732-1.942 2.714l.018 6.277c-.002-.98.646-1.964 1.942-2.713Z",
    fill: "url(#EmptyYourSquad_svg__I)",
    fillRule: "nonzero"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4F6",
    fillRule: "nonzero",
    d: "M6.07 202.52 3.45 201l.018 6.278 2.619 1.521z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#A3A9D0",
    fillRule: "nonzero",
    d: "m29.245 207.277-.018-6.278-2.636 1.522.019 6.277z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10.944 207.635c.508.145 1.022.269 1.541.37 1.637.246 1.99 2.03 1.993 2.781l-.018-6.277c-.003-.75-.356-2.535-1.992-2.782-.52-.1-1.034-.224-1.542-.37-1.476-.503-3.959.644-4.857 1.164l.019 6.277c.897-.52 3.38-1.667 4.856-1.163Z",
    fill: "url(#EmptyYourSquad_svg__J)",
    fillRule: "nonzero"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M19.474 208.259c.23-.131.484-.218.746-.255a18.622 18.622 0 0 0 1.542-.368c1.484-.505 3.955.642 4.848 1.162l-.019-6.277c-.892-.52-3.362-1.667-4.846-1.163-.509.145-1.024.268-1.543.369a2.121 2.121 0 0 0-.747.255c-1.01.584-1.226 1.919-1.282 2.555l.018 6.277c.057-.636.271-1.97 1.283-2.555Z",
    fill: "url(#EmptyYourSquad_svg__K)",
    fillRule: "nonzero"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M5.475 198.188c.865.857-1.125 2.291-2.024 2.81l2.618 1.522c.898-.52 3.381-1.666 4.857-1.163.508.146 1.023.27 1.542.37 1.657.249 1.998 2.077 1.992 2.81h3.713c.056-.636.272-1.971 1.282-2.555.231-.131.485-.218.747-.255.52-.101 1.035-.224 1.543-.369 1.484-.504 3.954.643 4.846 1.163l2.636-1.522c-.893-.519-2.868-1.954-1.994-2.81.241-.28.457-.579.645-.896.102-.187.258-.338.448-.433 1.024-.593 3.362-.731 4.406-.73l.013-2.153c-1.357.054-4.417-.203-4.842-1.166a6.13 6.13 0 0 0-.635-.894c-.863-.857 1.127-2.291 2.025-2.81l-2.617-1.522c-.9.519-3.383 1.667-4.857 1.164a18.65 18.65 0 0 0-1.542-.37c-1.659-.25-2-2.078-1.995-2.81l-3.716-.001c-.001.606-.248 1.961-1.273 2.553-.232.132-.487.22-.751.257-.526.103-1.043.226-1.545.371-1.711.369-3.952-.645-4.844-1.164l-2.635 1.522c.892.519 2.865 1.954 1.992 2.81a5.986 5.986 0 0 0-.644.895 1.041 1.041 0 0 1-.447.434c-1.025.591-3.363.73-4.413.73L0 196.13c1.263 0 4.416.203 4.84 1.164.184.318.396.617.635.895Zm6.258-5.831c2.58-1.49 6.745-1.49 9.308 0 2.561 1.49 2.55 3.904-.03 5.394-2.577 1.49-6.745 1.488-9.306-.001-2.563-1.49-2.55-3.904.028-5.393Z",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M3.451 200.999c.899-.52 2.889-1.954 2.024-2.81a5.893 5.893 0 0 1-.634-.896c-.425-.961-3.578-1.164-4.841-1.164l.018 6.277a15.749 15.749 0 0 1 3.438.37L3.45 201Z",
    fill: "#CED3F8",
    fillRule: "nonzero"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC1E4",
    fillRule: "nonzero",
    d: "m18.191 210.814-.018-6.277H14.46l.018 6.278h3.713z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m32.75 202.406-.018-6.277c-1.044 0-3.382.138-4.406.73-.19.096-.347.247-.448.434a6.248 6.248 0 0 1-.645.895c-.874.857 1.1 2.292 1.994 2.81l.006 1.804a15.474 15.474 0 0 1 3.517-.396Z",
    fill: "url(#EmptyYourSquad_svg__L)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421 176.879c-1.298-1.83-3.229-3.543-5.8-5.027-9.245-5.34-23.608-5.917-33.968-1.738l-4.426 1.048a28.603 28.603 0 0 0-3.6 1.738c-5.186 2.996-7.78 6.922-7.78 10.848 0 3.928 2.594 7.853 7.78 10.85 10.375 5.991 27.194 5.991 37.568 0 4.877-2.818 7.46-6.457 7.75-10.146.176-2.213-.476-4.444-1.95-6.525L421 176.88Z",
    fill: "url(#EmptyYourSquad_svg__M)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m371.761 161.046 15.184 12.586 18.785-10.848c-9.246-5.34-23.61-5.917-33.969-1.738Z",
    fill: "#807DFB",
    fillRule: "nonzero"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m405.73 162.784-18.785 10.848 24.584-5.82c-1.298-1.83-3.229-3.543-5.8-5.028Z",
    fill: "#FFD03E",
    fillRule: "nonzero"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m386.945 178.408-15.184-12.586a28.595 28.595 0 0 0-3.599 1.738c-5.186 2.996-7.78 6.922-7.78 10.848 0 3.928 2.593 7.853 7.78 10.85 10.375 5.991 27.194 5.991 37.568 0 4.877-2.818 7.46-6.457 7.75-10.146.176-2.213-.476-4.444-1.951-6.526l-24.584 5.822Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M413.48 179.112c-.29 3.689-2.873 7.328-7.75 10.146-10.374 5.991-27.193 5.99-37.568 0-4.876-2.818-7.459-6.457-7.751-10.146h-.03v4.638c0 3.926 2.594 7.852 7.781 10.848 10.375 5.991 27.194 5.991 37.568 0 4.877-2.818 7.46-6.456 7.75-10.145.03-.422.03-.846 0-1.268v-4.073Z",
    fill: "url(#EmptyYourSquad_svg__N)",
    fillRule: "nonzero"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#E19100",
    fillRule: "nonzero",
    d: "m411.529 172.586-24.584 5.822v-4.776l24.584-5.82v4.774z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#5652CC",
    fillRule: "nonzero",
    d: "m386.945 178.408-15.184-12.586v-4.776l15.184 12.586z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412.457 174.13a11.84 11.84 0 0 0-.928-1.544l-24.584 5.822h7.548l17.964-4.279Z",
    fill: "url(#EmptyYourSquad_svg__O)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyYourSquad_svg__P)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M357.343 287.54h39.602v2.993h-39.602z"
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A7776",
    fillRule: "nonzero",
    d: "m357.343 290.533-2.374-1.369V262.41l2.374 1.37v26.753z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D7271",
    fillRule: "nonzero",
    d: "m357.343 290.533 2.373-1.369V262.41l-2.373 1.37v26.753z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyYourSquad_svg__Q)",
    xlinkHref: "#EmptyYourSquad_svg__R"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptyYourSquad_svg__S)",
    xlinkHref: "#EmptyYourSquad_svg__R"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyYourSquad_svg__T)",
    xlinkHref: "#EmptyYourSquad_svg__U"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptyYourSquad_svg__V)",
    xlinkHref: "#EmptyYourSquad_svg__U"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyYourSquad_svg__W)",
    xlinkHref: "#EmptyYourSquad_svg__X"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptyYourSquad_svg__Y)",
    xlinkHref: "#EmptyYourSquad_svg__X"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyYourSquad_svg__Z)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M118.519 314.202h31.516v5.795h-31.516z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyYourSquad_svg__aa)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M104.156 305.841h31.513v5.794h-31.513z"
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M100.83 309.847c0-4.55 2.884-4.684 2.884-4.684s1.56 0 4.099-1.053c2.503-1.04 6.03-.637 4.058 3a.906.906 0 0 1-.067.135 1.78 1.78 0 0 1-.639.561l-6.301 3.698c-.962.547-4.012-.72-4.034-1.657Z",
    fill: "url(#EmptyYourSquad_svg__ab)",
    fillRule: "nonzero"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 309.44c.054.934 3.064 2.178 4.016 1.633l6.301-3.695c.315-.188.612-.405.887-.648-.056.125-.107.245-.18.38a.906.906 0 0 1-.068.135 1.78 1.78 0 0 1-.639.561l-6.301 3.698c-.9.514-3.633-.566-3.994-1.477a1.015 1.015 0 0 1-.029-.184 2.82 2.82 0 0 1 .007-.403Z",
    fill: "#121047",
    fillRule: "nonzero"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M102.003 304.565c.743 0 3.356.665 3.356.665.02.242.101.475.235.678.025.028.048.057.073.089.515.358 1.04.925-.184 1.693a1.698 1.698 0 0 1-2.203-.156 1.998 1.998 0 0 0-.711-.808 1.782 1.782 0 0 0-.681-.287.45.45 0 0 0-.006-.062s-.19-1.812.121-1.812Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M102.298 260.063c2.85.052 9.629.175 12.475.224-1.059 8.567-3.193 16.347-4.617 24.646-1.53 8.063-3.253 13.73-4.758 20.44-.55 1.249-3.07.776-3.58-.426-.399-6.18-.858-13.709.973-20.84-.305-7.685-1.334-15.102-.493-24.044Z",
    fill: "#131147",
    fillRule: "nonzero"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M115.195 318.21c0-4.55 2.882-4.683 2.882-4.683s1.562 0 4.1-1.052c2.501-1.041 6.03-.64 4.058 2.998-.02.047-.042.092-.067.136a1.766 1.766 0 0 1-.641.56l-6.3 3.698c-.961.547-4.01-.719-4.032-1.656Z",
    fill: "url(#EmptyYourSquad_svg__ac)",
    fillRule: "nonzero"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M115.21 317.802c.055.934 3.066 2.18 4.017 1.634l6.3-3.694a6.03 6.03 0 0 0 .89-.649c-.06.125-.108.246-.182.38-.02.047-.042.092-.067.136a1.766 1.766 0 0 1-.641.56l-6.3 3.698c-.898.514-3.633-.567-3.993-1.474a.83.83 0 0 1-.028-.186 3.097 3.097 0 0 1 .004-.405Z",
    fill: "#121047",
    fillRule: "nonzero"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M116.367 312.927c.741 0 3.356.666 3.356.666.02.242.1.474.232.678.027.03.05.058.073.088.517.359 1.043.925-.183 1.694a1.698 1.698 0 0 1-2.202-.154 2.03 2.03 0 0 0-.71-.809 1.812 1.812 0 0 0-.682-.287c-.001-.02-.003-.04-.007-.061 0 0-.189-1.815.123-1.815Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M110.996 280.428c-.78-3.682-10.543-4.25-8.725-18.62 2.82-.415 16.59 6.258 19.408 5.843.352 8.623-.48 16.65-.533 25.067-.192 8.204-.967 14.076-1.356 20.943-.339 1.324-2.901 1.268-3.602.167-1.402-6.033-3.084-13.387-2.44-20.72-.84-4.063-1.84-8.367-2.752-12.68Z",
    fill: "url(#EmptyYourSquad_svg__ad)",
    fillRule: "nonzero"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M103.167 240.625c-.874-2.902-1.7-13.382-1.473-16.073.227-2.691 3.966-15.028 3.966-15.028.984.5 2.783 1.283 2.783 1.283-.39 1.693-2.734 12.253-2.788 14.348-.055 2.094.695 9.79 1.562 10.622.867.83-4.05 4.848-4.05 4.848Z",
    fill: "url(#EmptyYourSquad_svg__ae)",
    fillRule: "nonzero"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M128.337 219.247c-.496 2.298-2.457 9.515-4.144 13.235-.817 1.8-3.436 4.232-5.346 5.707a2.208 2.208 0 0 1-2.486.143 31.95 31.95 0 0 1-2.326-1.56c-2.024-1.47-3.443-2.926-4.41-3.013-7.974-.715-7.579 12.135-7.884 28.345 1.045 3.873 3.625 6.13 6.609 7.39 6.058 2.559 12.024 1.896 13.616-2.267-1.584-7.24-2.836-12.948-2.157-20.131a27.509 27.509 0 0 0 8.619-12.151c1.848-5.483 2.827-13.39 2.94-14.797 0 0-1.283-.398-3.031-.9Z",
    fill: "url(#EmptyYourSquad_svg__af)",
    fillRule: "nonzero"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M105.052 235.768c1.269-1.672 1.317-4.075 1.073-5.751a8.28 8.28 0 0 1-.493-2.892c.023-3.73 2.419-6.935 5.326-6.714 5.858.441 4.795 3.518 4.77 7.246-.022 3.454-1.603 5.82-4.225 6.205-.003.567.538 1.596 1.427 2.07-1.497 1.657-4.328 1.953-5.53 1.798-1.279-.166-2.872-.938-2.348-1.962Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M113.168 218.453c-.168-.454-1.071-.704-4.02.643-.019.01-.716.331-.76.354-5.44 2.757-3.697 9.12-2.757 10.782.388.593.584 1.292.562 2.001 2.192-.223 2.96.97 4.292-.348.955-.943 2.401-2.07 2.629-2.518.162-.335.212-.713.14-1.079-.181-3.09 1.36-1.289 1.355-.578.567-.319.454-1.559.33-2.936 4.527-3.83 1.833-6.116-1.77-6.32Z",
    fill: "#121149",
    fillRule: "nonzero"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M128.643 219.336c.13-.429.176-1.246-.184-1.64-.36-.395-.786-2.378.37-2.682-.043-.372.814-1.262 2.126-.51 1.313.752 1.722 1.992 1.377 2.785-.346.793-1.147 2.1-1.265 2.766-.435-.132-2.424-.72-2.424-.72Zm-22.7-9.672c.168-.606-.373-2.324.037-3.144.41-.82 1.055-1.627 2.154-1.132 1.1.496 1.484 1.157 1.395 1.743a1.227 1.227 0 0 1-.226 1.8c-.777.63-1.017.949-1.208 1.723-.412-.183-2.153-.99-2.153-.99Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M127.64 236.911c-1.611 2.947-6.802 7.942-8.414 8.534-1.616.593-2.71 1.702-2.613 2.04.096.337 1.284 2.35 1.22 5.026-.065 2.673.592 13.959 3.92 15.167.073-.149.152-.293.213-.451-1.584-7.24-2.836-12.948-2.157-20.131 3.317-2.614 6.115-6.436 7.831-10.185Z",
    fill: "url(#EmptyYourSquad_svg__ag)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyYourSquad_svg__ah)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M380.923 146.132H355.27l-3.996 5.26h29.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyYourSquad_svg__ai)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M384.489 136.891h-22.153l-2.7 3.981h24.853z"
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M362.222 131.082c1.148-.782 2.958.548 3.415 2.027.02.637-.452 1.702-.452 1.702s-1.917 4.273-2.57 5c-.652.728-3.298 1.77-4.572.682-.915-1.186.901-1.895 1.233-3.07.432-1.528.246-2.75.671-3.902.35-.947 2.275-2.439 2.275-2.439Z",
    fill: "url(#EmptyYourSquad_svg__aj)",
    fillRule: "nonzero"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M365.527 132.816a.073.073 0 0 1 .006.017c.02.636-.45 1.702-.45 1.702s-1.919 4.271-2.57 5c-.653.728-3.3 1.772-4.574.682a1.582 1.582 0 0 1-.127-.195c.04.172.119.334.231.471 1.274 1.088 3.92.046 4.572-.683.653-.726 2.57-4.999 2.57-4.999s.472-1.065.452-1.702c-.031-.1-.068-.198-.11-.293Z",
    fill: "#140F4A",
    fillRule: "nonzero"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M359.072 132.048c.56-.382 2.874-1.222 2.874-1.222.14.171.32.305.523.389.033.008.066.021.101.033.572.004 1.608.542.968 1.692-1.241 2.236-4.11 2.157-3.794 1.096.214-.712-.375-1.552-.672-1.988Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M359.69 134.618c-.088-.353-.19-1.118.714-1.243.946-.135 2.015.303 1.927.859-.182 1.155-2.551.74-2.64.384Z",
    fill: "url(#EmptyYourSquad_svg__ak)",
    fillRule: "nonzero"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M363.226 130.869c-1.073-1.447-9.028-11.026-12.775-12.934 1.26-5.286 4.53-12.154 3.49-17.817h-7.98s-4.732 16.768-1.702 20.763c2.293 3.03 12.444 10.767 16.225 13.207 1.297 0 3.211-2.096 2.742-3.219Z",
    fill: "url(#EmptyYourSquad_svg__al)",
    fillRule: "nonzero"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M356.453 144.792c1.371.224 1.768 2.434 1.082 3.822-.425.476-1.5.923-1.5.923s-4.33 1.779-5.304 1.856c-.975.08-3.138-.286-3.314-1.95.167-1.018 1.02-1.297 2.07-1.92 1.365-.81 2.535-1.988 3.637-2.528.905-.445 3.329-.203 3.329-.203Z",
    fill: "url(#EmptyYourSquad_svg__am)",
    fillRule: "nonzero"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M350.761 150.947c1.002-.079 5.459-1.906 5.459-1.906a5.739 5.739 0 0 0 1.497-.91 3.172 3.172 0 0 1-.182.483c-.425.476-1.5.923-1.5.923s-4.33 1.779-5.304 1.856c-.975.08-3.138-.286-3.314-1.95.007-.034.019-.066.026-.102.459 1.371 2.401 1.681 3.318 1.606Z",
    fill: "#140F4A",
    fillRule: "nonzero"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M353.503 143.323c.668.11 2.927 1.092 2.927 1.092-.018.22.02.441.11.643l.052.092c.41.398.844 1.103-.412 1.498-2.438.766-4.516-.87-3.557-1.42.644-.37.795-1.386.88-1.905Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M352.209 145.556c.18-.241.603-.885 1.348-.354.778.556.953 1.222.863 1.778-.092.555-1.695.144-1.757.06-.06-.083-.454-1.484-.454-1.484Z",
    fill: "url(#EmptyYourSquad_svg__an)",
    fillRule: "nonzero"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M352.965 99.849c0 7.497-.08 15.882-.08 22.429 0 7.487-.572 16.77-.492 23.045 1.204 1.491 4.26 1.117 4.904-.036.795-5.696 2.569-14.37 2.13-20.588 1.895-8.192 4.266-17.929 3.495-24.357-1.813.576-8.143-1.069-9.957-.493Z",
    fill: "url(#EmptyYourSquad_svg__ao)",
    fillRule: "nonzero"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M350.915 69.63c-6.113 1.94-7.58 7.918-7.855 12.035-.18 2.71-.469 12.612 3.36 10.283 3.829-2.329 4.495-22.319 4.495-22.319Z",
    fill: "#DAE0F5",
    fillRule: "nonzero"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M362.553 73.928c-1.585-1.985-5.48-4.755-8.032-4.943-4.338-.32-7.774 3.267-8.66 6.264-.835 2.82-.376 24.13-1.307 27.966.46 2.022 4.178 3.117 5.588 3.427 6.123 1.343 13.106 1.105 13.587-2.779.9-7.259 1.112-27.647-1.176-29.935Z",
    fill: "url(#EmptyYourSquad_svg__ap)",
    fillRule: "nonzero"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m318.138 62.054-1.2 1.088c-.893.81-1.195 2.2-.65 3.62l.62 1.614 1.2-1.088-.62-1.615c-.544-1.42-.243-2.809.65-3.619ZM356.833 104.215l-1.201 1.088-16.103 3.543 1.2-1.088zM339.438 113.626c-1.805.397-3.88-.86-4.629-2.814l-.62-1.615-1.2 1.087.62 1.616c.75 1.953 2.823 3.21 4.629 2.813.497-.11-.016.517.324.21l2.138-1.938c-.357.32-.792.542-1.262.64ZM308.693 88.243l-1.2 1.088-6.682-17.414 1.2-1.087 6.682 17.413zM309.915 95.647c-1.806.397-3.88-.861-4.63-2.814-.543-1.416-.24-2.81.654-3.62l-1.2 1.087c-.895.81-1.197 2.204-.653 3.62.749 1.954 2.823 3.211 4.629 2.814l1.492-.328 1.2-1.088-1.492.329Z",
    fill: "#54AFAE",
    fillRule: "nonzero"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#54AFAE",
    fillRule: "nonzero",
    d: "m318.092 112.738-1.2 1.088-6.685-17.42 1.2-1.088 6.685 17.42zM334.19 109.197l-1.2 1.087-16.098 3.542 1.2-1.088 16.098-3.54z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M305.286 92.833c-.75-1.953.109-3.864 1.914-4.261l1.493-.329-6.682-17.413 16.097-3.542-.62-1.615c-.752-1.96.11-3.863 1.915-4.26 1.805-.398 3.876.868 4.625 2.822l.62 1.615 16.103-3.543 16.082 41.908-16.104 3.543.62 1.615c.75 1.953-.105 3.855-1.91 4.253-1.806.397-3.88-.86-4.63-2.814l-.62-1.615-16.097 3.541-6.684-17.42-1.493.329c-1.806.397-3.88-.861-4.63-2.814Z",
    fill: "#4DA5A4",
    fillRule: "nonzero"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M348.442 94.41c-.218.216-1.162 2.843.823 3.633 1.015-.534 1.355-3.205-.823-3.633Z",
    fill: "#392B99",
    fillRule: "nonzero"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m349.676 94.389-1.266.455c-.71.208-2.504-.143-3.505-1.145-1.002-1.003-1.21.985-.039 1.552 1.173.568 1.186 1.06-.706 1.4a4.74 4.74 0 0 0-2.115.963c-.678.678-1.43 2.18-.354 2.911.873.592 3.47-.575 4.257-.896 2.166-.881 1.732-1.31 2.947-1.888 1.215-.58 1.487-.556 1.487-.556l-.706-2.796Z",
    fill: "#FFCEA2",
    fillRule: "nonzero"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M359.734 73.003c1.364-.28 3.124-.044 4.315 4.005 1.007 3.42.197 10.452-.408 12.4-1.553 5.006-7.7 6.711-14.376 8.635.851-.974.285-3.13-.823-3.633 4.52-1.979 8.755-4.836 10.263-6.345 0-1.714-.835-8.205-.935-10.42-.125-2.755.616-4.365 1.964-4.642Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M355.067 63.224c.16-1.407-4.7 1.457-4.504 3.314.159 1.511.6 2.84-.928 3.786-.526.421-2.328 3.358.443 3.39 3.963.047 5.02-1.04 7.884-3.496-1.708-.966-3.41-2.435-2.895-6.994Z",
    fill: "#FFCEA2",
    fillRule: "nonzero"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m356.212 62.392-1.973-2.778h-8.591v5.172c0 2.859 1.923 5.173 4.294 5.173 2.303 0 4.441-1.907 4.553-4.645l1.042-.36.675-2.562Z",
    fill: "#FFCEA2",
    fillRule: "nonzero"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M350.142 71.343c2.052 0 4.593-3.299 4.353-6.027a4.957 4.957 0 0 1-4.38 4.639c-.15.136-.31.26-.48.369-.052.044-.1.093-.143.145 0 .417.276.874.65.874Z",
    fill: "#FBC096",
    fillRule: "nonzero"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M346.15 57.278c-.786-.137-.858-.79 2.327-1.893 1.85-.908 4.473-1.186 6.17-.136 2.3 1.425 2.994 3.519 2.581 6.146-.41 2.629-2.093 5.128-2.093 5.128-.255.257-.293-.954-.086-1.852.161-.228.264-.491.3-.768.61-2.67-1.024-2.271-1.247-2.046-.504.207.47 2.416-1.006 2.196-.714-.105-.617-2.1-.614-2.802-.109.022-.216.05-.321.085-1.22.677-5.362 1.17-3.062-.27-1.602 0-3.786.74-4.523-.277-.876-1.21.527-2.53 1.573-3.511Z",
    fill: "#231574",
    fillRule: "nonzero"
  }))));
};
export default SvgEmptyYourSquad;